import React from 'react';
import { HotkeyListener } from './hotkey';
import { ActiveListener, ActiveStageListener, PickStageListener } from './views/active-listener';
import { StoreListener } from './views/store-listener';

export const Listener: React.FC = React.memo(() => {
    return (
        <>
            <HotkeyListener />
            <ActiveListener />
            <ActiveStageListener />
            <PickStageListener />
            <StoreListener />
        </>
    );
});
